/**
 * 省市数据处理 - 纯函数，跨平台复用
 */

import type { ProvinceNode } from './types';

export function transformProvinceToNodes(data: any): ProvinceNode[] {
  if (!Array.isArray(data)) return [];
  return data.map((item: any) => ({
    value: item.value ?? item.regionCode ?? item.code,
    label: item.label ?? item.regionChnName ?? item.name ?? '',
    children: item.children ? transformProvinceToNodes(item.children) : undefined,
  }));
}
